import { Link, useLocation } from 'react-router-dom'
import { isNavActive, NAV_ITEMS } from '@/config/nav-items'
import { cn } from '@/lib/utils'

interface AppBottomNavProps {
  compact?: boolean
  className?: string
}

export function AppBottomNav({ compact = false, className }: AppBottomNavProps) {
  const location = useLocation()

  return (
    <nav
      className={cn(
        'fixed inset-x-0 bottom-0 z-40 border-t border-border bg-card/95 backdrop-blur supports-[backdrop-filter]:bg-card/80',
        'pb-[env(safe-area-inset-bottom)]',
        className,
      )}
      data-testid="app-bottom-nav"
      aria-label="Main navigation"
    >
      <ul className="mx-auto grid max-w-lg grid-cols-6">
        {NAV_ITEMS.map((item) => {
          const active = isNavActive(location.pathname, item.to)
          const Icon = item.icon

          return (
            <li key={item.to}>
              <Link
                to={item.to}
                className={cn(
                  'flex min-h-14 flex-col items-center justify-center gap-0.5 px-1 py-1 text-[10px] transition-colors',
                  active ? 'text-primary' : 'text-muted-foreground',
                )}
                data-testid={item.testId}
              >
                <Icon className="h-5 w-5 shrink-0" aria-hidden />
                <span className={cn('leading-none', compact && 'sr-only')}>{item.shortLabel}</span>
              </Link>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}
